// HOME POST SLIDER
jQuery(document).ready(function($) {
	
	$('.slider-posts-area').each(function (index, sliderWrap) {
		var $slider = $(sliderWrap).find('.slider');
		var $next = $(sliderWrap).find('.next');
		var $prev = $(sliderWrap).find('.prev');
		$slider.slick({
			dots: false,
			adaptiveHeight: true,
			slidesToShow: 2,
			slidesToScroll: 1,
			infinite: true,
			nextArrow: $next,
			prevArrow: $prev,
			responsive: [
			{
			  breakpoint: 1200,
			  settings: {
				slidesToShow: 1,
				adaptiveHeight: true,
				slidesToScroll: 1
			  }
			},
			// You can unslick at a given breakpoint now by adding:
			// settings: "unslick"
			// instead of a settings object
			]
		});
	});
});